export default __webpack_public_path__ + "static/BannerJsonImageAndTextWithAction-01eefbc3b4d8eec9c66696294bb85596.jpg";